export const hasWalletActivity = ({
    liveBalanceCount,
    pendingPostCount,
    lifetimeEarnings,
}: {
    liveBalanceCount: number;
    pendingPostCount: number;
    lifetimeEarnings: string | number;
}): boolean => liveBalanceCount > 0 || pendingPostCount > 0 || Number(lifetimeEarnings) > 0;
